<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="visible"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="handleClose()"
           [style]="{width:'750px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div style="color: #333333;">Employee Details</div>
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 190px)'}"
                       [styleClass]="'app-scrollpanel'">
            <div>
                <div class="bg-menu">
                    <p-tabMenu [model]="menuItems" [scrollable]="true" [activeItem]="menuItems[activeTab-1]"></p-tabMenu>
                </div>
                <div *ngIf="activeTab === menuTab.EmployeeDetail" class="menu-item-body">
                    <div class="flex flex-row" style="margin-bottom: 15px;">
                        <div style="color: #272D3B; font-size: 18px;">Personal Information</div>
                        <div class="flex flex-row" style="margin-left: auto;">
                            <div>Employee Status: </div>
                            <div [class]="'partner-employee-status-' + employee.StatusForClass">{{employee.StatusStr}}</div>
                        </div>
                    </div>

                    <div class="flex flex-row" style="margin-bottom: 20px;">
                        <div style="padding: 36px; align-items: center; justify-content: center; display: flex">
                            <div *ngIf="employee.ImageUrl" style="background-image: url({{employee.ImageUrl}}); cursor: pointer" (click)="handleInputClick('idImgInput')" class="image-filled"></div>
                            <div *ngIf="!employee.ImageUrl" (click)="handleInputClick('idImgInput')" style="background: #F2F5F7; width: 100px; height: 100px; border-radius: 50%; align-items: center; justify-content: center; display: flex; cursor: pointer">
                                <div style="color: #004060;">
                                    <i style="font-size: 25px; margin-left: 10px; font-weight: 700;" class="pi pi-upload"></i>
                                    <div>Upload</div>
                                </div>
                            </div>
                            <input id="idImgInput"
                                   type="file"
                                   accept="image/*"
                                   style="display: none"
                                   (change)="handleImageChange($event)" required />
                        </div>
                        <div>
                            <div class="flex flex-row">
                                <div>
                                    <div class="employee-input-label">First Name</div>
                                    <input pInputText type="text" [(ngModel)]="employee.FirstName" placeholder="First Name" class="employee-input-field input-name italic" />
                                </div>
                                <div style="margin-left: 20px;">
                                    <div class="employee-input-label">Last Name</div>
                                    <input class="employee-input-field input-name italic" type="text" [(ngModel)]="employee.LastName" placeholder="Last Name" pInputText />
                                </div>
                            </div>

                            <div class="employee-input-label">Home Address <a style=" color: #272D3B; font-size: 14px; font-weight: 300;">(optional)</a></div>
                            <p-autoComplete [(ngModel)]="employee.Address"
                                            [suggestions]="addresses"
                                            (completeMethod)="search($event)"
                                            placeholder="Search Google Maps"
                                            [inputStyle]="{'width': '420px', 'height': '47px', 'border': '0.5px solid rgba(0, 64, 96, 0.3019607843)'}">
                            </p-autoComplete>
                        </div>
                    </div>

                    <div class="flex flex-row">
                        <div style="margin-right: 30px; width: 290px;">
                            <div class="employee-input-label">Date of Birth</div>
                            <p-calendar [inputStyle]="{'border-radius': '6px', 'border': '0.5px solid rgba(0, 64, 96, 0.3019607843)', 'width': '275px', 'height': '42px'}"
                                        class="employee-input-field input-min" placeholder="mm/dd/yyyy" [(ngModel)]="employee.Birthday"></p-calendar>

                            <div class="employee-input-label" style="margin-top: 20px;">Cellphone Number</div>
                            <input class="employee-input-field input-min italic" type="text" [(ngModel)]="employee.Phone" placeholder="+63" pInputText />

                            <div class="employee-input-label" style="margin-top: 20px;">Role</div>
                            <p-dropdown [options]="merchantUserRoles" [(ngModel)]="employee.RoleId" placeholder="Select" optionLabel="name" optionValue="id" [style]="{width: '275px'}"></p-dropdown>
                        </div>

                        <div>
                            <div class="employee-input-label">Company ID <a style=" color: #272D3B; font-size: 14px; font-weight: 300;">(optional)</a></div>
                            <input class="employee-input-field input-min italic" type="text" [(ngModel)]="employee.ExternalId" placeholder="Employee ID" pInputText />

                            <div class="employee-input-label">Company Email</div>
                            <input class="employee-input-field input-min italic" type="text" [(ngModel)]="employee.Email" placeholder="Email" pInputText />
                        </div>
                    </div>
                </div>

                <div *ngIf="activeTab === menuTab.Store" class="menu-item-body">
                    <div class="employee-input-label" style="margin-bottom: 35px; width: 85%;">You may assign employees to multiple locations, however they can ONLY login to one location at a time.</div>
                    <div class="employee-input-label">Assign to Location:</div>
                    <p-dropdown [(ngModel)]="employee.StoreId" (onChange)="addStoreToUser($event)" [style]="{'width':'300px'}"
                                [options]="stores" placeholder="Search Location" optionLabel="Name" optionValue="Id" [showClear]="false"></p-dropdown>

                    <div *ngIf="employee.Store" style="margin-top: 20px;">
                        <div class="flex flex-row" style="width: 360px; height: 115px; box-shadow: 0px 3px 6px #3333331A; border: 0.5px solid #0040604D; border-radius: 10px; padding: 11px;">
                            <img [src]="employee.Store.ImageUrl" style="width: 90px; height: 90px; border-radius: 5px; margin-right: 15px;" />
                            <div style="width: 90%">
                                <div style="font-size: 16px; color: #272D3B; margin-top: 20px;">{{employee.Store.Name}}</div>
                                <div style="font-size: 10px; color: #272D3B; margin-top: 5px">{{employee.Store.Address}}</div>
                            </div>
                            <div>
                                <p-menu appendTo="body" #menu [model]="menuEditLocationItems" [popup]="true"></p-menu>
                                <button style="margin-left: auto; color: #000000; border: none; background: none" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-ellipsis-v"></button>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="activeTab === menuTab.Transactions" class="menu-item-body">
                    <div>Date range</div>
                    <div class="flex flex-row" style="margin: 10px 0px 10px 0px">
                        <div>
                            <p-calendar [inputStyle]="{'width': '130px', 'height':'45px'}" (ngModelChange)="handleFilterChange()" placeholder="From" [(ngModel)]="filter.startDate"></p-calendar>
                        </div>
                        <div style="margin-left: 15px;">
                            <p-calendar [inputStyle]="{'width': '130px', 'height':'45px'}" (ngModelChange)="handleFilterChange()" placeholder="To" [(ngModel)]="filter.endDate"></p-calendar>
                        </div>
                    </div>
                    <div style="margin-bottom: 10px; cursor: pointer; color: #00C0F0; text-decoration: underline; text-align: end;" (click)="handleFilterClear()"><div>Clear filter</div></div>
                    <!-- Table -->
                    <div style="height: calc(100vh - 380px);">
                        <p-table #merchantUsersGrid
                                 [columns]="transactionsCols"
                                 [value]="transactions"
                                 [lazy]="true"
                                 [loading]="loading"
                                 responsiveLayout="scroll" dataKey="UserId"
                                 (onLazyLoad)="handleLazyLoad($event)"
                                 [paginator]="true"
                                 [(first)]="first"
                                 [rows]="rowsPerPage"
                                 [rowsPerPageOptions]="rowsPerPageOptions"
                                 [totalRecords]="totalRecords"
                                 [resizableColumns]="true"
                                 [columnResizeMode]="'expand'"
                                 [autoLayout]="true"
                                 [styleClass]="'p-datatable-striped'"
                                 [scrollable]="true"
                                 [scrollHeight]="'flex'">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th *ngFor="let col of transactionsCols"
                                        [pSortableColumn]="col.field"
                                        [pSortableColumnDisabled]="col.disableSort"
                                        pResizableColumn
                                        [style.width]="col.width">
                                        {{col.header}}
                                        <p-sortIcon [field]="col.field"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-merchantUser>
                                <tr [pSelectableRow]="merchantUser">
                                    <td class="ui-resizable-column">{{merchantUser.StatusStr}}</td>
                                    <td class="ui-resizable-column">{{merchantUser.OrderId}}</td>
                                    <td class="ui-resizable-column">{{merchantUser.CreatedAt}}</td>
                                    <td class="ui-resizable-column">{{merchantUser.StoreName}}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="paginatorleft" let-state>
                                <div *ngIf="transactions.length > 0" style="padding-left: 10px">
                                    Displaying {{first + 1}} - {{first + transactions.length}} of {{totalRecords}}
                                </div>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

                <div *ngIf="activeTab === menuTab.AuditLog" class="menu-item-body">
                    AuditLog
                </div>
            </div>
        </p-scrollPanel>
        <hr class="hr-filter" />
        <div class="flex justify-content-end mrg-10-0px">
            <button *ngIf="activeTab === menuTab.EmployeeDetail" pButton [disabled]="loading" (click)="showResetPasswordDialog()"  class="p-button-text"  style="width: 172px; height: 45px; margin-right: 13px;"><ins>Reset Password</ins></button>
            <button *ngIf="activeTab === menuTab.EmployeeDetail" pButton [disabled]="loading" (click)="showSuspendEmployeeDialog()" label="Suspend Employee" class="outlined-orange-btn"  style="width: 172px; height: 45px; margin-right: 13px;"></button>
            <button *ngIf="activeTab === menuTab.EmployeeDetail" pButton [disabled]="loading" (click)="showDeleteEmployeeDialog()" class="red-btn"  label="Delete Employee" style="width: 172px; height: 45px;"></button>
            <button pButton [disabled]="loading" (click)="updateMerchantUser()" class="btn-darkblue" style="margin-left: 13px; width: 172px; height: 45px;"  label="Save"></button>
        </div>
    </div>

</p-sidebar>
<partner-delete-employee *ngIf="showDeleteEmployee" [showDeleteEmployee]="showDeleteEmployee" [merchantUser]="employee" [onHide]="handleDeleteEmployeeHide"></partner-delete-employee>
<partner-suspend-employee *ngIf="showSuspendEmployee" [showSuspendEmployee]="showSuspendEmployee" [merchantUser]="employee" [onHide]="handleSuspendEmployeeHide"></partner-suspend-employee>
<partner-employee-reset-password *ngIf="showResetPassword" [showResetPassword]="showResetPassword" [merchantUser]="employee" [onHide]="handleResetPasswordHide"></partner-employee-reset-password>